<template>
  <Modal class="max-w-[396px]! tablet-v:max-w-[500px]!" :hide-close="isMobile">
    <Modal.Body>
      <div class="flex items-center gap-x-3.5">
        <img
          :src="UpgradeMembershipCard"
          alt=""
          width="164"
          height="96"
          class="h-6 w-[41px] shrink-0"
        />
        <h2 class="text-[24px] font-medium leading-[28px] text-gray-800">
          {{ title }}
        </h2>
      </div>

      <p
        class="mt-2.5 text-[16px] leading-[22px] text-gray-800 tablet-v:text-[15px]"
      >
        {{ subtitle }}
      </p>

      <div class="mt-[30px] flex flex-col gap-y-[9px]">
        <div class="text-[15px] font-medium leading-[18px] text-gray-800">
          Included with Dacr Membership
        </div>

        <div v-for="feature in features" :key="feature.text" class="flex">
          <CheckmarkIcon class="mt-[3px] size-[13px] shrink-0 text-gray-800" />
          <div class="ml-3">
            <div class="text-[15px] leading-[18px] text-gray-800">
              {{ feature.text }}
            </div>
            <div
              v-if="feature.sub"
              class="mt-0.5 text-[13px] leading-[18px] text-gray-500"
            >
              {{ feature.sub }}
            </div>
          </div>
        </div>
      </div>

      <Button
        variant="primary"
        size="lg"
        class="mt-[30px] w-full"
        @click="handleSeePlans"
      >
        See plans
      </Button>
      <button
        type="button"
        class="mx-auto mt-[14px] block text-link text-[14px] tablet-v:hidden"
        @click="close()"
      >
        Not now
      </button>
    </Modal.Body>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { Modal, Button, useModal } from '@dacr/library'
import { CheckmarkIcon } from '@dacr/icons'
import { useDevice } from '@/shared/composables/useDevice'
import UpgradeMembershipCard from '@/assets/images/UpgradeMembershipCard.png'

const props = defineProps<{
  willReachLimit?: boolean
  hasReachedLimit?: boolean
}>()

const { close } = useModal()
const { isMobile } = useDevice()
const router = useRouter()

const features = [
  { text: 'Membership in the global community of protected creators' },
  { text: 'Dacr Membership card' },
  {
    text: 'Member-only events and benefits (Pro only)',
    sub: 'Workshops, creator events, discounts, and early access',
  },
  { text: 'Co-owners and authors on every registration' },
  { text: 'Register on behalf of others' },
  { text: 'Direct member support' },
]

const title = computed(() =>
  props.hasReachedLimit || props.willReachLimit
    ? 'Dacr Pro Membership'
    : 'Become a Dacr Member'
)

const subtitle = computed(() => {
  if (props.hasReachedLimit) {
    return 'You’ve reached your registration limit. You need a Pro Membership to register more work.'
  }
  if (props.willReachLimit) {
    return 'You’re about to reach your registration limit. You need a Pro Membership to register more work.'
  }
  return 'Do more with your work. Unlock everything a Dacr Membership offers.'
})

const handleSeePlans = () => {
  router.push('/upgrade')
  close()
}
</script>
